import { defineMessage, IntlShape } from "react-intl";

import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import selectEntityDialogFactory from "./selectEntityDialogFactory";

const noEntriesMessage = defineMessage({
  id: "selectEntityDialog.activityTypes.noEntries",
  defaultMessage: "No Activity Types found",
  description: "'No entries' message for the activity types modal",
});

const SelectActivityTypesModal = selectEntityDialogFactory<ActivityType>(
  noEntriesMessage,
  (allSelected: boolean, isFiltering: boolean, intl: IntlShape) =>
    (allSelected
      ? intl.formatMessage({
          id: "selectEntityDialog.activityTypes.deselectAll",
          defaultMessage: "Deselect All",
          description: "Deselect all message for the activity types modal",
        })
      : intl.formatMessage({
          id: "selectEntityDialog.activityTypes.selectAll",
          defaultMessage: "Select All",
          description: "Select all message for the activity types modal",
        })) +
    (isFiltering
      ? intl.formatMessage({
          id: "selectEntityDialog.activityTypes.filterTitle",
          defaultMessage: " Activity Types",
          description: "Filter title message for the activity types modal",
        })
      : "")
);
export default SelectActivityTypesModal;
